<template>
	<section>
		<fieldset>
			<div class="field-title mb-3">
		    	<div class="legend">Selecione o período e as opções desejadas</div>
		    </div>
			
			<div class="container-fluid">
				<div class="row">
					<div class="col-lg-4">
						<div class="form-group">
							<label for="toID">Período inicial:</label>
							<input type="date" class="form-control form-control-sm" v-model="filtro.inicio">
						</div>
					</div>

					<div class="col-lg-4">
						<div class="form-group">
							<label for="toID">Período final:</label>
							<input type="date" class="form-control form-control-sm" v-model="filtro.fim">
						</div>
					</div>

					<div class="col-lg-4">
						<div class="form-group">
							<label for="toID">Unidade:</label>
							<select class="form-control form-control-sm" v-model="filtro.unidade">
								<option value="0">Todos</option>
								<option v-for="uni in unidades" :value="uni.id">{{ uni.nome }}</option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</fieldset>

		<div class="d-flex flex-row-reverse bd-highlight">
			<router-link :to="{name: 'rel_resumo', params: { tab: 'Resumo', filtro, relatorio } }" class="btn btn-sm btn-primary">Próximo</router-link>
			<router-link :to="{name: 'rel_select' }" class="btn btn-sm btn-primary mr-1">Anterior</router-link>
		</div>

	</section>
</template>

<script>
	import api from "@/mixins/api.js"

	export default {
		name: 'Filtro',
		props: ["get", "relatorio"],
		mixins: [ api ],

		data() { 
			return { 
				unidades: null,
				filtro: { unidade: 0 }
			}
		},

		created() {
			this.set_rel_name();
			this.get_unidades();
		},

		methods: {
			async get_unidades() {
				const response = await this.GET("Unidade");

				if ( response.status == "success"){
					this.unidades = response.result;
				}
			},

			set_rel_name() {
				const type = this.relatorio;
				let   name = "";

				if ( type == "Detalhamento" ){
					name = "de detalhamento de ligações";
				}

				if ( type == "Fora-do-horario" ){
					name = "de ligações fora de horário";
				}

				if ( type == "0800" ){
					name = "de ligações por 0800";
				}

				this.$emit('update_name', name);
			}
		}
	};
</script>

<style>
</style>